import Style from "./Progress.module.scss";
import type { MouseEvent } from "react";

export const ProgressBar = (props: {
    className?: string,
    onChange: (v: number, e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>)=>void,
    value: number
}) => {
    return <div className={`progress ${props.className ? props.className : ""} ${Style.Progress}`} onClick={e => {
        const bounds = e.currentTarget.getBoundingClientRect();
        const max = bounds.width //Get width element
        const pos = e.pageX - bounds.left; //Position cursor
        const dual = pos / max; // Round %
        props.onChange(dual, e);
    }}>
        <div className={"progress-bar"} style={{width: `${100*props.value}%`}} />
    </div>
}
